import React, {useContext, useEffect, useState} from 'react'
import {getLocal} from '../../../../hooks/useStorage/useStorage.jsx'

import {
    EditRounded as EditRoundedIcon,
    DeleteRounded as DeleteRoundedIcon,
    MoreVert as MoreIcon
} from '@mui/icons-material'
import {AddressContext} from '../../../../context/AddressContext.jsx'
import {FormControlLabel, IconButton, Menu, MenuItem, Radio} from '@mui/material'

import {capitalizeFirstLetter, checkUndefined} from 'react-lf-tools'
import {textBodyColor} from '../../../../metrics.module.scss'

import {general as textsGeneral} from '../../../../translate/Translate.jsx'

import './addressList.scss'

const AddressList = ({myAddress, onClick, onEdit, onDelete}) => {

    const {deliveryMode} = useContext(AddressContext)
    const [takeawayOptions, setTakeawayOptions] = useState([])
    const [storesLocations, setStoresLocations] = useState([])
    const [anchorEl, setAnchorEl] = useState()
    const [address, setAddress] = useState(null)
    const open = Boolean(anchorEl)
    const handleClick = (event, address) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
        setAddress(address)
    }
    const handleClose = (event) => {
        event.stopPropagation()
        setAnchorEl(null)
    }

    const checkSelectedAddress = (id) => {
        const address = getLocal('address', {id: ''})
        return (address.id === id)
    }

    const checkSelectedTakeawayOptions = (option) => {
        const takeawayOptions = getLocal('takeawayOptions')
        return (takeawayOptions.store === option)
    }

    const handleClickList = (event, value, type) => {
        event.stopPropagation()
        onClick(value, type)
    }

    const checkTakeawayOptions = () => {
        const data = getLocal('data', {})
        const takeawayOptions = checkUndefined(data.takeawayOptions, [])
        setTakeawayOptions(takeawayOptions)
        const storesLocations = checkUndefined(data.storesLocations, [])
        setStoresLocations(storesLocations)
    }
    useEffect(() => checkTakeawayOptions(), [])

    const menuItemStyle = {
        gap: 10,
        alignItems: 'center',
        fontFamily: 'Nunito',
    }

    return <div className={'address-list'}>
        {(() => {
            if (deliveryMode === 'delivery') {
                return myAddress.map((a, i) => <div
                    key={i}
                    className={'div-address-list'}
                    id={checkSelectedAddress(a.id) ? 'div-address-list-selected' : ''}>
                    <div className={'div-container-title-address-list'}>
                        <FormControlLabel
                            onChange={(event) => handleClickList(event, a, 'delivery')}
                            sx={{
                                '& .MuiTypography-root': {
                                    fontWeight: 'bold',
                                    color: textBodyColor,
                                    userSelect: 'none'
                                }
                            }}
                            label={`${a.street}, ${a.number}`}
                            control={<Radio
                                color={'secondary'}
                                style={{color: textBodyColor}}
                                checked={checkSelectedAddress(a.id)}/>}
                        />
                        <IconButton onClick={(e) => handleClick(e, a)}>
                            <MoreIcon className={'icon-address-list'}/>
                        </IconButton>
                        <Menu

                            anchorEl={anchorEl}
                            open={open}
                            onClose={(event) => handleClose(event)}>
                            <MenuItem style={menuItemStyle} onClick={(event) => {
                                onEdit(event, address)
                                handleClose(event)
                            }}>
                                <EditRoundedIcon className={'icon-address-list'}/>
                                {textsGeneral.toEdit}
                            </MenuItem>
                            <MenuItem style={menuItemStyle} onClick={(event) => {
                                onDelete(event, address)
                                handleClose(event)
                            }}>
                                <DeleteRoundedIcon className={'icon-address-list'}/>
                                {textsGeneral.toDelete}
                            </MenuItem>
                        </Menu>
                    </div>
                    <label className={'div-description-address-list'}>
                        {`${a.neighborhood} - ${a.city}, ${a.uf}`}
                    </label>
                    <label className={'div-description-address-list'}>
                        {a.addressComplement}
                    </label>
                </div>)
            } else if (deliveryMode === 'takeaway') {
                if (storesLocations.length !== 0) {
                    return storesLocations.map((t, i) => <div
                        key={i}
                        className={'div-address-list'}
                        id={checkSelectedTakeawayOptions(t) ? 'div-address-list-selected' : ''}>
                        <div className={'div-container-title-address-list'}>
                            <FormControlLabel
                                onChange={(event) => handleClickList(event, t, 'storesLocations')}
                                sx={{
                                    '& .MuiTypography-root': {
                                        fontWeight: 'bold',
                                        color: textBodyColor,
                                        userSelect: 'none'
                                    }
                                }}
                                label={capitalizeFirstLetter(t.address)}
                                control={<Radio
                                    color={'secondary'}
                                    style={{color: textBodyColor}}
                                    checked={checkSelectedTakeawayOptions(t)}
                                />}
                            />
                        </div>
                    </div>)
                } else {
                    return takeawayOptions.map((t, i) => <div
                        key={i}
                        className={'div-address-list'}
                        id={checkSelectedTakeawayOptions(t) ? 'div-address-list-selected' : ''}>
                        <div className={'div-container-title-address-list'}>
                            <FormControlLabel
                                onChange={(event) => handleClickList(event, t, 'takeaway')}
                                sx={{
                                    '& .MuiTypography-root': {
                                        fontWeight: 'bold',
                                        color: textBodyColor,
                                        userSelect: 'none'
                                    }
                                }}
                                label={t}
                                control={<Radio
                                    color={'secondary'}
                                    style={{color: textBodyColor}}
                                    checked={checkSelectedTakeawayOptions(t)}
                                />}
                            />
                        </div>
                    </div>)
                }
            }
        })()}
    </div>
}

export default AddressList
